<template>
  <vs-switch id="insights-table-adsets-switch-button" class="mt-5" @click="updateStatus()" :value="isSelected"></vs-switch>
</template>

<script>
export default {
  data () {
    return {
      isSelected: false
    }
  },
  beforeMount () {
    this.isSelected = this.params.data.activation_status === 1
  },
  methods: {
    async updateStatus () {
      const item = this.params.data

      const isAdset = item.children_count || false

      let response = null

      if (isAdset) { // this is adset
        response = await this.updateAdset(item)
      } else {
        response = await this.updateAd(item)
      }

      if (!response) {
        return
      }

      this.updateTableRows(isAdset, response)
    },
    async updateAdset (adset) {
      return await window.axios.post(`/campaigns/${adset.campaign_id}/update-adset-activation-status`, {
        status: adset.activation_status === 1 ? 'Paused' : 'Active',
        adset_id: adset.id,
        _method: 'PATCH'
      })
    },
    async updateAd (ad) {
      return await window.axios.post(`/campaigns/${ad.campaign_id}/update-ad-activation-status`, {
        status: ad.activation_status === 1 ? 'Paused' : 'Active',
        ad_id: ad.id,
        _method: 'PATCH'
      })
    },
    updateTableRows (isAdset, response) {
      // update the adset status when updating the ad
      if (!isAdset) {
        this.params.node.parent.setData({
          ...this.params.node.parent.data,
          aggregated_status: response.data.payload.adset_aggregated_status
        })

        this.$nextTick(() => {
          this.params.api.refreshCells({
            rowNodes: [this.params.node.parent],
            force: true
          })
        })
      } else {
        this.params.api.purgeServerSideCache()
      }

      this.params.node.setData({
        ...this.params.node.data,
        activation_status: response.data.payload.activation_status,
        aggregated_status: response.data.payload.aggregated_status
      })

      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })

      this.$root.$emit('campaign-adsets-or-ads-status-updated')
    }
  }
}
</script>
